import { render, staticRenderFns } from "./PaymentItemsModal.vue?vue&type=template&id=4d3b0a7d&"
import script from "./PaymentItemsModal.vue?vue&type=script&lang=js&"
export * from "./PaymentItemsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports